// SeekingAlpha rating helpers.
// Headline ratings are on a 1–5 scale; factor grades arrive as integers we map to letter grades.

const MUTED = '#5f6b7a';

/** Color for a 1–5 headline rating: >=3.5 green (Buy), 2.5–3.5 amber (Hold), <2.5 red (Sell). */
export function ratingColor(value?: number | null): string {
    if (value == null || Number.isNaN(value)) return MUTED;
    if (value >= 3.5) return '#037f0c';
    if (value >= 2.5) return '#8d6605';
    return '#d91515';
}

/**
 * Color for a SeekingAlpha factor grade. The grade is shown as its raw number; lower is better
 * (1 = A+ = dark green), worsening toward red as the number rises. Muted for missing/invalid.
 */
export function gradeColor(n?: number | null): string {
    if (n == null || Number.isNaN(n)) return MUTED;
    const r = Math.round(n);
    if (r < 1) return MUTED;
    if (r === 1) return '#0b6b2e';  // best — dark green
    if (r <= 4) return '#037f0c';   // green
    if (r <= 7) return '#8d6605';   // amber
    if (r <= 10) return '#cc6b00';  // orange
    return '#d91515';               // 11+ — red (worst)
}

/**
 * Normalize a Trading 212 ticker (e.g. "aapl_us_eq") to the short, upper-case symbol ("AAPL").
 * The backend keys the ratings response by upper-case symbol, so request-building and lookups
 * must use the same casing or rows silently miss their data.
 */
export function shortTicker(ticker?: string | null): string {
    return (ticker?.split('_')[0] ?? '').toUpperCase();
}
